import React from 'react'
import { type FieldValues, type UseFormRegister } from 'react-hook-form'

import styles from './styles.module.scss'

const Checkbox = ({
  onChange,
  name,
  id,
  label,
  register,
  required = true,
  isError = false,
  className,
  checkColor,
  checkboxClassName,
}: {
  register?: UseFormRegister<FieldValues>
  isError?: boolean
  value?: string
  required?: boolean
  checked?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  name: string
  id?: string
  label?: string | JSX.Element
  disabled?: boolean
  className?: string
  /** Color of the checkmark when checked */
  checkColor?: string
  checkboxClassName?: string
}) => {
  return (
    <div
      className={className ? `${styles.input} ${className}` : styles.input}
      style={checkColor ? ({ '--check-color': checkColor } as React.CSSProperties) : undefined}
    >
      <input
        id={id}
        type="checkbox"
        name={name}
        onChange={onChange}
        {...register?.(name, {
          required,
        })}
      />
      <label htmlFor={id} className={isError ? styles.error : styles.label}>
        <div className={`${styles.checkbox} ${checkboxClassName || ''}`}></div>
        {label}
      </label>
    </div>
  )
}
export default Checkbox
